import inputStyle from "./InputField.module.css";
import styles from "./TextareaField.module.css";
import PropTypes from "prop-types";
import classNames from "classnames/bind";
import Field from "./Field";

export default function TextareaField({
  disabled,
  errorList = [],
  id,
  labelText,
  name,
  placeholder,
  required = true,
}) {
  return (
    <Field id={id} labelText={labelText} errorList={errorList}>
      <textarea
        required={required}
        id={id}
        name={name}
        className={classNames(styles.TextareaField, inputStyle.InputField)}
        placeholder={placeholder}
        disabled={disabled}
      />
    </Field>
  );
}

TextareaField.propTypes = {
  disabled: PropTypes.bool,
  errorList: PropTypes.arrayOf(PropTypes.string),
  id: PropTypes.string.isRequired,
  labelText: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
};
